module.exports = __webpack_public_path__ + "img/profile.7574c8d0.png";